// Real service photos downloaded from the backend (same images as admin panel)
import applianceRepair from "../assets/service-backgrounds/appliance_repair.webp";
import bbqCleaning from "../assets/service-backgrounds/bbq_cleaning.webp";
import carpetCleaning from "../assets/service-backgrounds/carpet_cleaning.webp";
import ductCleaning from "../assets/service-backgrounds/duct_cleaning.webp";
import electrical from "../assets/service-backgrounds/electrical.webp";
import junkRemoval from "../assets/service-backgrounds/junk_removal.webp";
import decksFences from "../assets/service-backgrounds/decks_fences.webp";
import furnitureAssembly from "../assets/service-backgrounds/furniture_assembly.webp";
import garageDoor from "../assets/service-backgrounds/garage_door.webp";
import gasServices from "../assets/service-backgrounds/gas_services.webp";
import lawnMaintenance from "../assets/service-backgrounds/lawn_maintenance.webp";
import heatingCooling from "../assets/service-backgrounds/heating_cooling.webp";
import locksmith from "../assets/service-backgrounds/locksmith.webp";
import painting from "../assets/service-backgrounds/painting.webp";
import pestControl from "../assets/service-backgrounds/pest_control.webp";
import pestControlAnnual from "../assets/service-backgrounds/pest_control_annual.webp";
import powerWash from "../assets/service-backgrounds/power_wash.webp";
import windowCleaning from "../assets/service-backgrounds/window_cleaning.webp";
import roofing from "../assets/service-backgrounds/roofing.webp";
import plumbing from "../assets/service-backgrounds/plumbing.webp";
import moving from "../assets/service-backgrounds/moving.webp";
import seasonalLawn from "../assets/service-backgrounds/seasonal_lawn.webp";
import handyman from "../assets/service-backgrounds/handyman.webp";
import mulchArea from "../assets/service-backgrounds/mulch_area.webp";
import organizing from "../assets/service-backgrounds/organizing.webp";
import acTuneUp from "../assets/service-backgrounds/ac_tune_up.webp";
import artificialTurf from "../assets/service-backgrounds/artificial_turf.webp";
import snowRemoval from "../assets/service-backgrounds/snow_removal.webp";
import bathtubCaulking from "../assets/service-backgrounds/bathtub_caulking.webp";
import smartHome from "../assets/service-backgrounds/smart_home.webp";
import sodInstallation from "../assets/service-backgrounds/sod_installation.webp";
import stoneInterlock from "../assets/service-backgrounds/stone_interlock.webp";
import tileGrout from "../assets/service-backgrounds/tile_grout.webp";
import treeServices from "../assets/service-backgrounds/tree_services.webp";
import tvMounting from "../assets/service-backgrounds/tv_mounting.webp";
import waspTreatment from "../assets/service-backgrounds/wasp_treatment.webp";
import waterDamage from "../assets/service-backgrounds/water_damage.webp";
import yardCleanup from "../assets/service-backgrounds/yard_cleanup.jpg";
import deepCleaning from "../assets/service-backgrounds/deep_cleaning.webp";
import dishwasherInstall from "../assets/service-backgrounds/dishwasher_install.webp";
import dryerVent from "../assets/service-backgrounds/dryer_vent.webp";
import drywallRepair from "../assets/service-backgrounds/drywall_repair.webp";
import eavestrough from "../assets/service-backgrounds/eavestrough.webp";
import exteriorCaulking from "../assets/service-backgrounds/exterior_caulking.webp";
import flooring from "../assets/service-backgrounds/flooring.webp";
import furnaceTuneUp from "../assets/service-backgrounds/furnace_tune_up.webp";
import gasFireplace from "../assets/service-backgrounds/gas_fireplace.webp";
import applianceInstall from "../assets/service-backgrounds/appliance_install.webp";

// Map service name (case-insensitive partial match) to local image
// IMPORTANT: More specific entries must come BEFORE generic ones
const SERVICE_IMAGE_MAP = [
  // Appliance — specific before generic
  { keywords: ["appliance install"], image: applianceInstall },
  { keywords: ["appliance"], image: applianceRepair },

  { keywords: ["bbq", "barbecue", "grill"], image: bbqCleaning },
  { keywords: ["carpet", "upholstery"], image: carpetCleaning },
  { keywords: ["duct"], image: ductCleaning },
  { keywords: ["electrical", "electric"], image: electrical },
  { keywords: ["junk", "haul"], image: junkRemoval },
  { keywords: ["deck", "fence"], image: decksFences },

  // Dishwasher before generic "wash"
  { keywords: ["dishwasher"], image: dishwasherInstall },

  { keywords: ["furniture", "assembly"], image: furnitureAssembly },
  { keywords: ["garage"], image: garageDoor },

  // Gas fireplace before generic "gas"
  { keywords: ["gas fireplace", "fireplace"], image: gasFireplace },
  { keywords: ["gas"], image: gasServices },

  // Furnace before generic "tune-up"
  { keywords: ["furnace"], image: furnaceTuneUp },
  { keywords: ["ac tune", "tune-up", "tune up"], image: acTuneUp },

  { keywords: ["seasonal lawn", "seasonal"], image: seasonalLawn },

  // Yard clean before generic "yard"
  { keywords: ["yard clean"], image: yardCleanup },
  { keywords: ["lawn", "garden", "yard", "grass"], image: lawnMaintenance },

  { keywords: ["heating", "cooling", "hvac", "air conditioning"], image: heatingCooling },
  { keywords: ["artificial turf", "turf"], image: artificialTurf },

  // Locksmith — removed broad "lock" to avoid matching "interlock"
  { keywords: ["locksmith", "key"], image: locksmith },

  { keywords: ["paint"], image: painting },
  { keywords: ["pest control annual", "annual"], image: pestControlAnnual },
  { keywords: ["pest", "insect", "bug", "wasp", "hornet", "bee"], image: pestControl },
  { keywords: ["wasp", "hornet", "bee"], image: waspTreatment },
  { keywords: ["plumb", "pipe", "drain"], image: plumbing },

  // Power wash
  { keywords: ["power", "wash", "pressure", "stain", "seal"], image: powerWash },

  // Eavestrough before generic "eave"
  { keywords: ["eavestrough", "flashing", "siding"], image: eavestrough },
  { keywords: ["window", "eave", "gutter"], image: windowCleaning },

  { keywords: ["roof"], image: roofing },
  { keywords: ["moving", "delivery", "move"], image: moving },
  { keywords: ["mulch"], image: mulchArea },
  { keywords: ["organiz", "declutter", "packing"], image: organizing },
  { keywords: ["snow"], image: snowRemoval },
  { keywords: ["handyman"], image: handyman },

  // Exterior caulking before generic "caulk"
  { keywords: ["exterior caulk"], image: exteriorCaulking },
  { keywords: ["bathtub", "shower", "caulk"], image: bathtubCaulking },

  { keywords: ["smart home", "smart"], image: smartHome },
  { keywords: ["sod"], image: sodInstallation },

  // Stone/interlock — now safe since "lock" removed from locksmith
  { keywords: ["stone", "interlock", "concrete", "patio"], image: stoneInterlock },

  { keywords: ["tile", "grout"], image: tileGrout },
  { keywords: ["tree", "stump"], image: treeServices },
  { keywords: ["tv", "television", "mount"], image: tvMounting },
  { keywords: ["water damage", "sewage", "flood"], image: waterDamage },
  { keywords: ["deep clean", "deep"], image: deepCleaning },
  { keywords: ["dryer vent", "dryer"], image: dryerVent },
  { keywords: ["drywall"], image: drywallRepair },
  { keywords: ["floor"], image: flooring },
  { keywords: ["holiday", "light", "christmas"], image: handyman },
  { keywords: ["auto", "car", "detail", "mobile"], image: handyman },
  { keywords: ["inspection"], image: handyman },
];

/**
 * Returns a local image for a given service name.
 * Falls back to the handyman image if no match is found.
 */
export const getServiceLocalImage = (serviceName) => {
  if (!serviceName) return handyman;
  const lower = serviceName.toLowerCase();
  for (const entry of SERVICE_IMAGE_MAP) {
    if (entry.keywords.some((kw) => lower.includes(kw))) {
      return entry.image;
    }
  }
  return handyman;
};
